export var TooltipPlacements = /*#__PURE__*/function (TooltipPlacements) {
  TooltipPlacements["TOP"] = "top";
  TooltipPlacements["BOTTOM"] = "bottom";
  TooltipPlacements["LEFT"] = "left";
  TooltipPlacements["RIGHT"] = "right";
  TooltipPlacements["TOPSTART"] = "top-start";
  TooltipPlacements["BOTTOMSTART"] = "bottom-start";
  TooltipPlacements["LEFTSTART"] = "left-start";
  TooltipPlacements["RIGHTSTART"] = "right-start";
  TooltipPlacements["TOPEND"] = "top-end";
  TooltipPlacements["BOTTOMEND"] = "bottom-end";
  TooltipPlacements["LEFTEND"] = "left-end";
  TooltipPlacements["RIGHTEND"] = "right-end";
  TooltipPlacements["AUTO"] = "auto";
  return TooltipPlacements;
}(TooltipPlacements || {});